"use client"
import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Col, Container, Row} from 'react-bootstrap';
import {hardGray, hover, softWhite, text, white} from '@/styles/globalStyleVars';
import SocialShare from "@/components/common/SocialShare";
import {usePathname} from "next/navigation";
import {Img} from "@/components/common/ui/Img";
import VideoDetails from "@/components/details/VideoDetails";
import {gsap} from "gsap";
import useDeviceTypeTab from "@/components/hooks/useDeviceTypeTab";
import VisitButton from "@/components/common/ui/VisitButton";
import DownloadBrochure from "@/components/common/ui/DownloadBrochure";
import Button from "@/components/common/ui/Button";
import InnerBanner from "@/components/common/InnerBanner";
import Intro from "@/components/details-ui/Intro";
import Description from "@/components/details-ui/Description";
import KeyPopUp from "@/components/common/forms/KeyPopUP";
import {useGSAP} from "@gsap/react";
import KeyPopUPIelts from "@/components/common/forms/KeyPopUPIelts";
import {useShowSetting} from "@/app/ShowSettingProvider";
const Details = ({data, mainData}) => {

    const detailsRef = useRef();
    const leftWrapperRef = useRef(null);
    useGSAP(() => {
        const col4Element = document.querySelector('.social-pin-wrapper');
        const rightWrapperElement = document.querySelector('.details__right');

        if (window.innerWidth >= 768) { // Apply pinning only for non-mobile devices
            gsap.to(col4Element, {
                scrollTrigger: {
                    trigger: col4Element,
                    start: 'top +160',
                    end: () => `+=${rightWrapperElement.scrollHeight - 100}`,
                    pin: true,
                    pinSpacing: false
                }
            });
        }
    }, [mainData]);

    const isMobile = useDeviceTypeTab();


    let sections_list = mainData?.data?.sections;
    const file = mainData?.data?.sections?.find(
        (f) => f?.section_data?.template === "blog_intro"
    );

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);


    };

    const showSetting = useShowSetting();

    return (
        <StyledDetails className="details-wrapper">
            <KeyPopUPIelts lefttitle={showSetting?.data?.ietls_modal_title} subtitle={showSetting?.data?.ietls_modal_subtitle} show={show} handleClose={handleClose}/>

            <Container>
                <Row ref={detailsRef}>
                    {
                        isMobile ?
                            <Col md={12} className={'forMobile'}>
                                <div ref={leftWrapperRef} className="mobilefooter ">
                                    <SocialShare/>
                                    {
                                        file?.files?.list?.[0]?.full_path &&
                                        <DownloadBrochure  className={'visit-btn'} text={'Download Brochure'} margin={'20px 0 0'} src={file?.files?.list?.[0]?.full_path} target={'_blank'} width={'100%'}/>

                                    }
                                    <Button onClick={handleShow} text={'Submit Your Interest'} src={'javascript:void(0)'} margin={'20px 0 0'} border={'1px solid'} width={'100%'} borderColor={text} background={'transparent'} color={text} hoverBackground={hover} hoverColor={white}/>

                                </div>
                            </Col>
                            : ''
                    }
                    <Col md={{span: 3}} >
                        <div ref={leftWrapperRef} className="social-pin-wrapper ">
                            {
                                !isMobile ?
                                    <div className="social-wrapper-main">
                                        <SocialShare/>
                                        {
                                            file?.files?.list?.[0]?.full_path &&
                                            <DownloadBrochure  className={'visit-btn'} text={'Download Brochure'} margin={'20px 0 0'} src={file?.files?.list?.[0]?.full_path} target={'_blank'} width={'100%'}/>

                                        }

                                        <Button onClick={handleShow} text={'Submit Your Interest'} src={'javascript:void(0)'} margin={'20px 0 0'} border={'1px solid'} width={'100%'} borderColor={text} background={'transparent'} color={text} hoverBackground={hover} hoverColor={white}/>

                                    </div>
                                    :
                                    ''
                            }
                        </div>

                    </Col>

                    <Col md={{span: 8, offset: 1}} className={'details__right'} ref={detailsRef}>

                        {
                            sections_list?.length > 0 && sections_list.map((item, index) => {
                                switch (item?.section_data?.template) {
                                    case 'blog_intro':
                                        return (
                                            <React.Fragment key={index}>
                                                <Intro data={item}/>
                                            </React.Fragment>
                                        );
                                    case 'blog_video':
                                        return (
                                            <React.Fragment key={index}>
                                                <VideoDetails image={item?.images?.list?.[0]?.full_path} link={item?.section_data?.subtitle}/>
                                            </React.Fragment>
                                        );
                                    case 'blog_description':
                                        return (
                                            <React.Fragment key={index}>
                                                <Description data={item}/>
                                            </React.Fragment>
                                        );
                                    default:
                                        return null; // If the template doesn't match any case, render nothing
                                }
                            })
                        }








                    </Col>

                </Row>
            </Container>
        </StyledDetails>
    );
};

const StyledDetails = styled.section`
    padding: 80px 0 200px;
    background: ${softWhite};
    position: relative;

    @media (max-width: 767px) {
        padding: 0 0 120px;
        .forMobile {
            padding: 0 !important;
            margin-bottom: 60px;

        }
   
        .social-list-wrap-div {
            padding: 0 15px;

        }

        .mobilefooter {
            .dc-btn {
                height: 60px;
                max-width: 50% !important;
                float: left;

                &.visit-btn {
                    a {
                        background: ${hover} !important;
                    }
                }

                a {
                    border-radius: 0 !important;
                    border: none;
                    background: ${text};
                    padding: 0 15px !important;
                    @media (max-width: 400px) {
                        font-size: 12px;
                        line-height: 18px;
                    }
                    &:before{
                        display: none !important;
                    }
                    span {
                        color: ${white} !important;
                    }

                }
            }
        }
    }


    .caption {
        font-weight: 500;
        margin-top: 20px;
    }

    .mobilefooter {
        .dc-btn {
            max-width: 270px;
        }

        .social {
            align-items: flex-start !important;
            justify-content: flex-start !important;
        }
    }

    .video-modal {
        margin-bottom: 30px;
    }

    .caption {
        margin-bottom: 60px;
    }


    .top-go-back-button {
        top: 0;
        position: absolute;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;

        @media (max-width: 992px) and (min-width: 768px) {
            top: -10px;
        }

        li {
            flex: 0 0 50%;
            max-width: 50%;
            padding: 20px 15px;
            display: flex;
            cursor: pointer;

            p {
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;
            }

            &:first-child {
                background: white;

                svg {
                    margin-right: 20px;
                }
            }

            &:last-child {
                justify-content: flex-end;

                svg {
                    margin-left: 20px;
                }

                p {
                    color: white
                }

                background: ${hover};
            }
        }
    }


    .small-box-cta {
        margin-top: 20px;
    }

    //introduction

    .intro {
        margin-bottom: 30px;
        display: flex;

        &.border-bottom-new {
            border-bottom: 4px solid ${hover} !important;

        }

        .intro-left {
            flex: 0 0 80%;
            max-width: 80%;

            img {
                width: auto;
            }

            h1 {
                font-size: 32px;
                line-height: 40px;
                letter-spacing: -0.32px;
                font-weight: 500;
                color: ${text};
                margin-top: 30px;
                margin-bottom: 20px;
            }
        }

        .intro-right {
            flex: 0 0 20%;
            max-width: 20%;

            .box-wrapper {
                position: relative;
                padding-top: calc(130 / 170 * 100%);
                background: ${hover};
                height: 100%;
                border-radius: 5px;

                svg {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    opacity: 0.1;
                }

                .content {
                    position: absolute;
                    inset: 0;
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 15px;

                    p {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                        letter-spacing: -1.05px;
                        color: ${white};

                        &.ranking {
                            color: ${white};
                            font-size: 32px;
                            line-height: 40px;
                            letter-spacing: -0.32px;
                            font-weight: 500;
                        }
                    }
                }
            }
        }
    }


    //banner

    .banner {
        margin-bottom: 60px;

        .campus {
            margin-bottom: 30px;
            display: flex;
            flex-wrap: wrap;
            gap: 30px;

            .campus-single {
                flex: 0 0 calc(33.333333% - 60px);
                max-width: calc(33.333333% - 60px);
                margin-right: 30px;

                &:last-child {
                    margin-right: 0;
                }

                h5 {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    letter-spacing: -0.12px;
                    color: ${hardGray};
                    margin-bottom: 10px;
                }

                p {
                    color: ${text};
                    margin: 0;
                }
            }
        }

        .banner-wrapper {
            position: relative;
            padding-top: calc(480 / 870 * 100%);
            margin: 60px 0;

            .global-image {
                border-radius: 10px;
            }
        }
    }
    //course list
    .course-list-wrapper {
        margin-top: 30px;
        padding-bottom: 60px;
        border-bottom: 1px solid #040504;
        margin-bottom: 60px;

        h2 {
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            color: ${hover};
            margin-bottom: 30px;
        }

        .course-list {

            display: flex;
            gap: 30px;
            flex-flow: wrap;
        }

        .course-single {
            flex: 0 0 calc(33.3333% - 30px);
            max-width: calc(33.3333% - 30px);
        }
    }
    //description
    .mb-bottom {
        margin-bottom: 60px;
    }
    .overview {
        p {
            line-height: 20px;
            a{
                color: ${hover};
                text-decoration: underline;
            }
        }
    }
    p {
        line-height: 20px;
        a{
            color: ${hover};
            text-decoration: underline;
        }
    }
    .detail-description {
        .nzuac-list-count {
            margin-bottom: 20px;

            span {
                display: block;
                font-weight: 500;
            }

            li {
                &:last-child {
                    &:before {
                        display: none;
                    }
                }
            }
        }

        h2 {
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            color: ${hover};
            margin-bottom: 20px;
        }

        table {
            gap: 20px;
            margin-bottom: 60px;

            th {
                font-size: 16px; /* 20px / 15px = 1.3333rem */
                font-weight: 400;
                line-height: 20px; /* 28px / 15px = 1.8667rem */
                color: ${text};
                border-top: none !important;
            }

            tr {
                border-bottom: 1px solid rgba(20, 38, 55, 0.2);
                justify-content: flex-start;
                padding: 20px 0;
                display: flex;
                flex-wrap: wrap;
                gap: 30px;
                font-size: 16px; /* 20px / 15px = 1.3333rem */
                font-weight: 400;
                line-height: 20px; /* 28px / 15px = 1.8667rem */

                &:first-child {
                    border-bottom: 1px solid rgba(4, 5, 4, 0.2);
                    padding-top: 0;
                }

                &:last-child {
                    border-bottom: none;
                }

                th {
                    max-width: calc(50% - 30px);
                    flex: 0 0 calc(50% - 30px);
                }

                td {
                    max-width: calc(50% - 30px);
                    flex: 0 0 calc(50% - 30px);
                }
            }
        }

        ul {
            margin-top: 0;
            margin-bottom: 60px;

            li {
                border-bottom: 1px solid rgba(4, 5, 4, 0.2);
                font-size: 16px;
                font-weight: 400;

                strong {
                    font-weight: 500;
                }
            }
        }

        a {
            color: ${hover};
            margin-bottom: 20px;
            display: inline-block;
        }

        &.mb-bottom {
            a {
                color: ${hover};
                margin-top: 20px;
                display: inline-block;
            }
        }
    }
    .image-gallery-slider {
        position: relative;
        margin-bottom: 60px;

        .navigation {
            position: absolute;
            bottom: -35px;
            right: 0;
        }

        .img-wrapper-big {
            padding-top: calc(570 / 870 * 100%);
            position: relative;
        }

        .swiper-slide-active {
            p {
                transition-delay: 0.7s;
                opacity: 1;
            }
        }

        p {
            opacity: 0;
            transition: 0.7s all cubic-bezier(0.54, 0.32, 0.05, 0.96);
            max-width: 70%;
            margin-top: 35px;
            font-weight: 500;
        }
    }
    .video-modal {
        margin: 60px 0;

        .global-image {
            border-radius: 10px;
        }
    }
    h2, h3, h4, h5, h6 {
        margin-bottom: 20px;
        
        strong{
            font-weight: 500;
            color: ${hover}
        }
    }

    //responsive
    @media (max-width: 992px) {
        .col-md-3 {
            display: none;
        }

        .col-md-8 {
            flex: 0 0 100%;
            max-width: 100%;
            margin: 0;
        }

        .course-list-wrapper {
            .course-single {
                max-width: calc(50% - 15px);
                flex: 0 0 calc(50% - 15px);
            }
        }
    }
    @media (max-width: 767px) {
        .intro {
            display: flex;
            align-items: flex-start;
            position: relative;

            .intro-left {
                flex: 0 0 100%;
                max-width: 100%;
            }

            .intro-right {
                flex: unset;
                max-width: unset;
                position: absolute;
                right: 0;
                top: 0;


                .box-wrapper {
                    position: unset;
                    padding-top: unset;
                    background: transparent;

                    .global-image {
                        display: none;
                    }

                    .content {
                        position: unset;
                        inset: unset;
                        padding: 0;

                        p {
                            color: #888888;

                            &.ranking {
                                color: ${hover};
                            }
                        }
                    }
                }
            }
        }

        .banner {
            .campus {
                flex-direction: column;

                .campus-single {
                    flex: 0 0 100%;
                    max-width: 100%;
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .course-list-wrapper {
            .course-box {
                padding-top: calc(120 / 345 * 100%);
            }

            .course-single {
                max-width: 100%;
                flex: 0 0 100%;
            }
        }
    }
`;

export default React.memo(Details);




